import { Controller } from "@hotwired/stimulus"

/**
 * Sidebar Controller - 管理移动端侧边栏显示/隐藏
 */
export default class extends Controller {
  static targets = ["menu", "backdrop"]

  toggle() {
    if (this.hasMenuTarget && this.hasBackdropTarget) {
      const isOpen = !this.menuTarget.classList.contains("-translate-x-full")
      if (isOpen) {
        this.close()
      } else {
        this.open()
      }
    }
  }

  open() {
    if (this.hasMenuTarget && this.hasBackdropTarget) {
      this.menuTarget.classList.remove("-translate-x-full")
      this.menuTarget.classList.add("translate-x-0")
      this.backdropTarget.classList.remove("hidden")
    }
  }

  close() {
    if (this.hasMenuTarget && this.hasBackdropTarget) {
      this.menuTarget.classList.add("-translate-x-full")
      this.menuTarget.classList.remove("translate-x-0")
      this.backdropTarget.classList.add("hidden")
    }
  }
}
